import { motion } from "framer-motion";
import { useEffect } from "react";

interface RocketDeliveryProps {
  active: boolean;
  onLanded: () => void;
}

const RocketDelivery = ({ active, onLanded }: RocketDeliveryProps) => {
  useEffect(() => {
    if (!active) return;
    const timer = setTimeout(onLanded, 1800);
    return () => clearTimeout(timer);
  }, [active, onLanded]);

  if (!active) return null;

  return (
    <div className="relative h-44 w-72 overflow-hidden rounded-2xl bg-sky-100">
      <motion.div
        className="absolute text-6xl"
        initial={{ x: -80, y: 120, rotate: -20, opacity: 0 }}
        animate={{ x: 140, y: 20, rotate: 5, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        🚀
      </motion.div>
      <motion.div
        className="absolute text-3xl"
        initial={{ x: -40, y: 130, opacity: 0 }}
        animate={{ x: 95, y: 52, opacity: [0, 0.8, 0] }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        💨
      </motion.div>
      <motion.p
        className="absolute bottom-3 left-0 right-0 text-center text-sm font-bold text-slate-600"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        Flying to your toy shelf...
      </motion.p>
    </div>
  );
};

export default RocketDelivery;